(function () {
  if (window.__bcCalculatorPopupInitialized) return;
  window.__bcCalculatorPopupInitialized = true;

  function parseMaybeNumber(value) {
    if (value == null) return NaN;
    var text = String(value).trim().replace(',', '.');
    if (!text) return NaN;
    return parseFloat(text);
  }

  function toPositiveNumberOrZero(value) {
    var n = parseMaybeNumber(value);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  function isPositiveInteger(value) {
    return Number.isFinite(value) && value > 0 && Math.floor(value) === value;
  }

  function formatMetersFromCm(cm) {
    return (cm / 100).toLocaleString('nl-NL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }) + ' m';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function initCalculator(wrapper) {
    if (!wrapper || wrapper.dataset.bcInitialized === 'true') return;
    wrapper.dataset.bcInitialized = 'true';

    var cutMarginCm = 6;

    var rollWidthCm = parseMaybeNumber(wrapper.dataset.rolBreedte);
    var rollLengthCm = parseMaybeNumber(wrapper.dataset.rolLengte);

    var patternHeightCm = toPositiveNumberOrZero(wrapper.dataset.patroonHoogte);
    var offsetCm = toPositiveNumberOrZero(wrapper.dataset.verspringingCm);

    var wallCounter = 1;
    var instanceId = wrapper.dataset.bcCalculator;

    var specsEl = wrapper.querySelector('[data-bc-specs]');
    var wallsContainer = wrapper.querySelector('[data-bc-walls]');
    var addWallBtn = wrapper.querySelector('[data-bc-add-wall]');
    var calculateBtn = wrapper.querySelector('[data-bc-calculate]');
    var errorEl = wrapper.querySelector('[data-bc-error]');
    var resultEl = wrapper.querySelector('[data-bc-result]');
    var resultNumberEl = wrapper.querySelector('[data-bc-result-number]');
    var resultSubEl = wrapper.querySelector('[data-bc-result-sub]');
    var detailsEl = wrapper.querySelector('[data-bc-details]');

    function renderSpecs() {
      if (!specsEl) return;

      var html = '';

      if (Number.isFinite(rollWidthCm) && rollWidthCm > 0) {
        html += '<span class="bc-spec-tag">Rolbreedte: ' + rollWidthCm + ' cm</span>';
      }
      if (Number.isFinite(rollLengthCm) && rollLengthCm > 0) {
        html += '<span class="bc-spec-tag">Rollengte: ' + formatMetersFromCm(rollLengthCm) + '</span>';
      }
      if (patternHeightCm > 0) {
        html += '<span class="bc-spec-tag">Patroonhoogte: ' + patternHeightCm + ' cm</span>';
      } else {
        html += '<span class="bc-spec-tag">Patroonhoogte: geen</span>';
      }
      if (patternHeightCm > 0 && offsetCm > 0) {
        html += '<span class="bc-spec-tag">Verspringing: ' + offsetCm + ' cm</span>';
      }
      html += '<span class="bc-spec-tag">Snijmarge: ' + cutMarginCm + ' cm</span>';

      specsEl.innerHTML = html;
    }

    function showError(message) {
      if (!errorEl || !resultEl) return;
      errorEl.textContent = message;
      errorEl.classList.add('bc-visible');
      resultEl.classList.remove('bc-visible');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.classList.remove('bc-visible');
    }

    function renumberWalls() {
      var walls = wallsContainer.querySelectorAll('.bc-wall');
      for (var i = 0; i < walls.length; i++) {
        var index = i + 1;
        var wall = walls[i];

        wall.dataset.wall = String(index);
        wall.querySelector('.bc-wall-label').textContent = 'Wand ' + index;

        var widthInput = wall.querySelector('.bc-input-breedte');
        var heightInput = wall.querySelector('.bc-input-hoogte');
        var labels = wall.querySelectorAll('.bc-field label');

        var widthId = instanceId + '-breedte-' + index;
        var heightId = instanceId + '-hoogte-' + index;

        widthInput.id = widthId;
        heightInput.id = heightId;

        labels[0].setAttribute('for', widthId);
        labels[1].setAttribute('for', heightId);
      }

      wallCounter = walls.length;
    }

    function createWallBlock(index) {
      var div = document.createElement('div');
      div.className = 'bc-wall';
      div.dataset.wall = index;

      div.innerHTML =
        '<div class="bc-wall-header">' +
          '<span class="bc-wall-label">Wand ' + index + '</span>' +
          '<button type="button" class="bc-wall-remove" aria-label="Verwijder wand" title="Verwijder wand">&times;</button>' +
        '</div>' +
        '<div class="bc-wall-fields">' +
          '<div class="bc-field">' +
            '<label for="' + instanceId + '-breedte-' + index + '">Breedte</label>' +
            '<div class="bc-field-input">' +
              '<input id="' + instanceId + '-breedte-' + index + '" type="number" class="bc-input-breedte" placeholder="Bijv. 350" step="1" min="1" inputmode="numeric">' +
              '<span class="bc-field-unit">cm</span>' +
            '</div>' +
          '</div>' +
          '<div class="bc-field">' +
            '<label for="' + instanceId + '-hoogte-' + index + '">Hoogte</label>' +
            '<div class="bc-field-input">' +
              '<input id="' + instanceId + '-hoogte-' + index + '" type="number" class="bc-input-hoogte" placeholder="Bijv. 265" step="1" min="1" inputmode="numeric">' +
              '<span class="bc-field-unit">cm</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      div.querySelector('.bc-wall-remove').addEventListener('click', function () {
        div.remove();
        renumberWalls();
      });

      return div;
    }

    function calculateStripLengthCm(wallHeightCm) {
      var baseLength = wallHeightCm + cutMarginCm;

      if (patternHeightCm > 0 && offsetCm > 0) {
        baseLength += offsetCm;
      }

      if (patternHeightCm <= 0) return baseLength;
      return Math.ceil(baseLength / patternHeightCm) * patternHeightCm;
    }

    function calculateWalls() {
      var wallElements = wallsContainer.querySelectorAll('.bc-wall');
      var wallsCalculated = [];

      for (var i = 0; i < wallElements.length; i++) {
        var wallIndex = i + 1;
        var wallElement = wallElements[i];

        var widthValue = parseMaybeNumber(wallElement.querySelector('.bc-input-breedte').value);
        var heightValue = parseMaybeNumber(wallElement.querySelector('.bc-input-hoogte').value);

        if (!isPositiveInteger(widthValue) || !isPositiveInteger(heightValue)) {
          return { error: 'Vul voor elke wand een geldige breedte en hoogte in (hele centimeters).' };
        }

        if (widthValue > 10000 || heightValue > 2000) {
          return { error: 'Een ingevoerde maat lijkt onrealistisch hoog. Controleer of je centimeters hebt ingevuld.' };
        }

        if (!Number.isFinite(rollWidthCm) || rollWidthCm <= 0 || !Number.isFinite(rollLengthCm) || rollLengthCm <= 0) {
          return { error: 'Productgegevens ontbreken of zijn ongeldig (rolbreedte of rollengte).' };
        }

        var stripsNeeded = Math.ceil(widthValue / rollWidthCm);
        var stripLengthCm = calculateStripLengthCm(heightValue);

        if (stripLengthCm > rollLengthCm) {
          return {
            error:
              'De benodigde baanlengte voor wand ' + wallIndex +
              ' is ' + Math.round(stripLengthCm) + ' cm en past niet binnen de rollengte van ' +
              Math.round(rollLengthCm) + ' cm.'
          };
        }

        var stripsPerRoll = Math.floor(rollLengthCm / stripLengthCm);
        if (stripsPerRoll < 1) {
          return { error: 'Onmogelijke berekening voor wand ' + wallIndex + '. Controleer productgegevens en invoer.' };
        }

        wallsCalculated.push({
          wallIndex: wallIndex,
          widthCm: widthValue,
          heightCm: heightValue,
          stripsNeeded: stripsNeeded,
          stripLengthCm: stripLengthCm,
          stripsPerRoll: stripsPerRoll
        });
      }

      return { wallsCalculated: wallsCalculated };
    }

    function groupByStripLength(wallsCalculated) {
      var groupsMap = {};

      for (var i = 0; i < wallsCalculated.length; i++) {
        var wall = wallsCalculated[i];
        var key = String(wall.stripLengthCm);

        if (!groupsMap[key]) {
          groupsMap[key] = {
            stripLengthCm: wall.stripLengthCm,
            stripsPerRoll: wall.stripsPerRoll,
            totalStrips: 0,
            wallNumbers: []
          };
        }

        groupsMap[key].totalStrips += wall.stripsNeeded;
        groupsMap[key].wallNumbers.push(wall.wallIndex);
      }

      var groups = Object.keys(groupsMap).map(function (key) {
        var group = groupsMap[key];
        group.rollsNeeded = Math.ceil(group.totalStrips / group.stripsPerRoll);
        return group;
      });

      groups.sort(function (a, b) {
        return a.stripLengthCm - b.stripLengthCm;
      });

      return groups;
    }

    function renderDetails(wallsCalculated, lengthGroups, totalRolls) {
      var html = '';

      html += '<p><strong>Zo rekenen we:</strong> per wand berekenen we eerst het aantal banen. Daarna berekenen we de snijlengte per baan (hoogte + snijmarge';
      if (patternHeightCm > 0 && offsetCm > 0) html += ' + verspringing';
      html += '). Als er een patroonhoogte is, ronden we daarna naar boven af op een veelvoud van de patroonhoogte. Wanden met dezelfde snijlengte worden samengevoegd voor de rolberekening.</p>';

      html += '<table>';
      html += '<tr><th>Wand</th><th>Afmeting</th><th>Banen</th><th>Snijlengte</th><th>Banen/rol</th></tr>';

      for (var i = 0; i < wallsCalculated.length; i++) {
        var wall = wallsCalculated[i];
        html += '<tr>' +
          '<td>' + wall.wallIndex + '</td>' +
          '<td>' + wall.widthCm + ' x ' + wall.heightCm + ' cm</td>' +
          '<td>' + wall.stripsNeeded + '</td>' +
          '<td>' + Math.round(wall.stripLengthCm) + ' cm</td>' +
          '<td>' + wall.stripsPerRoll + '</td>' +
        '</tr>';
      }

      html += '</table>';

      html += '<p><strong>Samengevoegde rolberekening per snijlengte</strong></p>';
      html += '<table>';
      html += '<tr><th>Wanden</th><th>Snijlengte</th><th>Totaal banen</th><th>Banen/rol</th><th>Rollen</th></tr>';

      for (var g = 0; g < lengthGroups.length; g++) {
        var group = lengthGroups[g];
        html += '<tr>' +
          '<td>' + escapeHtml(group.wallNumbers.join(', ')) + '</td>' +
          '<td>' + Math.round(group.stripLengthCm) + ' cm</td>' +
          '<td>' + group.totalStrips + '</td>' +
          '<td>' + group.stripsPerRoll + '</td>' +
          '<td>' + group.rollsNeeded + '</td>' +
        '</tr>';
      }

      html += '</table>';
      html += '<p><strong>Totaal berekend:</strong> ' + totalRolls + ' rol(len).</p>';

      detailsEl.innerHTML = html;
    }

    function calculateAndRender() {
      clearError();

      if (!Number.isFinite(rollWidthCm) || rollWidthCm <= 0 || !Number.isFinite(rollLengthCm) || rollLengthCm <= 0) {
        showError('Productgegevens ontbreken of zijn ongeldig (rolbreedte of rollengte).');
        return;
      }

      var wallCalcResult = calculateWalls();
      if (wallCalcResult.error) {
        showError(wallCalcResult.error);
        return;
      }

      var wallsCalculated = wallCalcResult.wallsCalculated;
      var lengthGroups = groupByStripLength(wallsCalculated);

      var totalRolls = 0;
      for (var i = 0; i < lengthGroups.length; i++) totalRolls += lengthGroups[i].rollsNeeded;

      resultNumberEl.textContent = totalRolls;
      if (resultSubEl) resultSubEl.textContent = '';

      renderDetails(wallsCalculated, lengthGroups, totalRolls);
      resultEl.classList.add('bc-visible');
    }

    renderSpecs();

    addWallBtn.addEventListener('click', function () {
      wallCounter = wallsContainer.querySelectorAll('.bc-wall').length;
      var nextWallIndex = wallCounter + 1;
      wallsContainer.appendChild(createWallBlock(nextWallIndex));
      wallCounter = nextWallIndex;
    });

    calculateBtn.addEventListener('click', calculateAndRender);
  }

  function openModal(modal) {
    if (!modal) return;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var topBarOffset = getTopBarOffset();
    modal.style.setProperty('--bc-safe-top', topBarOffset + 'px');

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var topBarOffset = getTopBarOffset();
    modal.style.setProperty('--bc-safe-top', topBarOffset + 'px');

    var wrapper = modal.querySelector('[data-bc-calculator]');
    if (wrapper) initCalculator(wrapper);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    var firstInput = modal.querySelector('.bc-input-breedte');
    if (firstInput) {
      setTimeout(function () {
        firstInput.focus();
      }, 10);
    }
  }

  function getTopBarOffset() {
    var candidates = document.querySelectorAll('header, [data-header], .header, .site-header, .shopify-section-header-sticky');
    var maxBottom = 0;

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var style = window.getComputedStyle(el);
      var position = style.position;

      if (position !== 'fixed' && position !== 'sticky') continue;

      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0) {
        maxBottom = Math.max(maxBottom, rect.bottom);
      }
    }

    return Math.max(0, Math.round(maxBottom));
  }

  function getTopBarOffset() {
    var candidates = document.querySelectorAll('header, [data-header], .header, .site-header, .shopify-section-header-sticky');
    var maxBottom = 0;

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var style = window.getComputedStyle(el);
      var position = style.position;

      if (position !== 'fixed' && position !== 'sticky') continue;

      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0) {
        maxBottom = Math.max(maxBottom, rect.bottom);
      }
    }

    return Math.max(0, Math.round(maxBottom));
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-bc-open]');
    if (openBtn) {
      var openId = openBtn.getAttribute('data-bc-open');
      var modal = document.querySelector('[data-bc-modal="' + openId + '"]');
      openModal(modal);
      return;
    }

    var closeBtn = event.target.closest('[data-bc-close]');
    if (closeBtn) {
      var closeId = closeBtn.getAttribute('data-bc-close');
      var closeModalEl = document.querySelector('[data-bc-modal="' + closeId + '"]');
      closeModal(closeModalEl);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('.bc-modal.is-open');
    if (modal) closeModal(modal);
  });
})();